/******************************************************************
 * Archivo : client/src/components/Admin/surveys/SurveyViewer/ViewerResult/index.js
 * Proyecto: CB30
 ******************************************************************/

import React from "react";

const ViewerResult = ({ encuesta, resultado }) => {

 console.log(JSON.stringify(resultado, null, 2));

  return (

    <div className="card mt-3">

      <div className="card-header">

        <strong>{encuesta.titulo}</strong>

      </div>

      <div className="card-body">

  

  <p>
    <strong>Survey Id:</strong> {encuesta.surveyId}
  </p>

  <p>
    <strong>Survey Result Id:</strong> {encuesta.surveyResultsId}
  </p>

<hr />

<h5>Respuestas</h5>

<ul className="list-group">

  {
    (resultado.results || []).map((item, index) => (

      <li
        key={index}
        className="list-group-item"
      >

      <strong>{item.pregunta}</strong>

      {" : "}

      {item.respuesta}

      </li>

    ))
  }

</ul>

</div>

    </div>

  );

};

export default ViewerResult;


// WEBPACK FOOTER //
// ./src/components/Admin/surveys/SurveyViewer/ViewerResult/index.js